module.exports = __webpack_public_path__ + "static/media/Decisions_Step6_Image0.715275a6.webp";